import React from 'react'

function DevWeb() {
  return (
    <div></div>
  )
}

export default DevWeb